import { inject } from '@angular/core';
import { InvitationsService } from '@invitations/infra';
import { map, Observable, switchMap } from 'rxjs';
import { ActivatedRoute, Params } from '@angular/router';
import { CreateManyGameInvitationsDto, SendGameInvitationsPathParams } from '@core-http';
import { InvitePlayersCommandPayload } from './invite-players.command-payload';

export class InvitePlayersCommandHandler {
  private readonly invitationsService: InvitationsService = inject(InvitationsService);
  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);

  sendInvitations(payload: InvitePlayersCommandPayload): Observable<void> {
    const requestPayload: CreateManyGameInvitationsDto = payload;

    return this.activatedRoute.params.pipe(
      switchMap((params: Params) => {
        const pathParams: SendGameInvitationsPathParams = { hostedGameId: params['id'] };
        return this.invitationsService.invite(pathParams, requestPayload);
      }),
      map(() => void 0)
    );
  }
}
